import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Settings({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Settings'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

